// extracted by mini-css-extract-plugin
export default {"Box":"delete-field-dialog-module__Box--oNVYA","Text":"delete-field-dialog-module__Text--c7X5I"};